import React, { useCallback } from 'react';
import { pick, prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { Link } from 'js/components/common/Link';
import { htcmdService } from 'js/services/htcmd.service';
import { useUserSelector, useAppSelector } from 'js/store/hooks';

import style from './UserVerificationBanner.scss';

export const UserVerificationBanner = ({ path }) => {
    const { DTAG_PROFILE_PAGE } = useAppSelector(prop('dynamicTags'));
    const translate = useTranslations('playtech.mobile.system.verificationStatus.banner.');
    const {
        isLoggedIn, isUserVerified, isUserKycMadeOnce, isUserKycMadeTwice, documentUploadRequirements, userVerificationTagsFetched
    } = useUserSelector(
        pick(['isLoggedIn', 'isUserVerified', 'isUserKycMadeOnce', 'isUserKycMadeTwice', 'documentUploadRequirements', 'userVerificationTagsFetched']));

    const handleLinkClick = useCallback((e) => {
        if (htcmdService.isEnabled) {
            e.preventDefault();
            htcmdService.openExternalPage(location.origin + DTAG_PROFILE_PAGE);
        }
    }, [DTAG_PROFILE_PAGE]);

    if (!isLoggedIn || !userVerificationTagsFetched || isUserVerified || path === DTAG_PROFILE_PAGE) {
        return null;
    }

    if (!(isUserKycMadeOnce || isUserKycMadeTwice || ['pending', 'optional', 'mandatory'].includes(documentUploadRequirements))) {
        return null;
    }

    const myAccountLink = <Link href={DTAG_PROFILE_PAGE} className={style.link} onClick={handleLinkClick} >{translate('myAccountLink')}</Link>;
    const messageTemplate = translate('message');

    const message = messageTemplate.includes('{0}')
        ? <>{messageTemplate.split('{0}')[0]}{myAccountLink}{messageTemplate.split('{0}')[1]}</>
        : messageTemplate;

    return (
        <div className={`${style.banner} user-verification-banner`}>
            <div className={style.icon} />
            <div className={style.text}>{message}</div>
        </div>
    );
};
